import { get } from 'lodash'
import routes from '~/const/routes'

export const state = () => ({
  items: [],
  meta: {
    totalItems: null
  },
  requestParams: null
})

export const getters = {
  items: state => state.items,
  meta: state => state.meta,
  requestParams: state => state.requestParams
}

export const mutations = {
  RESET(state) {
    state.items = []
    state.meta = { totalItems: null }
    state.requestParams = null
  }
}

export const actions = {
  async getAll({ commit }, { params = {}, config = {} }) {
    const { data, meta } = get(
      await this.$axios.get(routes.integrations.list(), {
        params: params || {},
        ...config
      }),
      'data'
    )

    commit(
      'AFTER_GET_ALL',
      {
        namespace: 'integrations',
        items: data,
        meta,
        params: config.params
      },
      { root: true }
    )

    return { data, meta }
  },
  async create({ commit }, { payload = {}, config = {} }) {
    const data = get(await this.$axios.post(routes.integrations.list(), payload, config), 'data')
    commit(
      'AFTER_CREATE',
      {
        namespace: 'integrations',
        item: data
      },
      { root: true }
    )
    return data
  },
  async update({ commit }, { id, payload = {}, config = {} }) {
    const data = get(
      await this.$axios.put(routes.integrations.concrete(id), payload, config),
      'data'
    )
    commit(
      'AFTER_UPDATE',
      {
        namespace: 'integrations',
        item: data
      },
      { root: true }
    )
    return data
  }
}
